// extracted by mini-css-extract-plugin
export default {"contactsContainer":"contacts_contactsContainer__zGNOc"};